import Model from 'models/model';

import { translations } from 'i18n';
import { IUser, IDevice } from '../types/user';

export default class User extends Model<IUser> {
  constructor(...args: any) {
    super({...args});

    this.createGetters(['id', 'device']);
  }

  static selectFromState(state: any) {
    const { currentUser } = state.registry;

    return new User({
      ...currentUser
    });
  }

  get deviceName() {
    const { productName } = this._get('device') || {};

    if (!productName) {
      const {
        device: { deviceName }
      } = translations;

      return deviceName.source();
    }

    return productName;
  }
}
